import React, { useState } from 'react';
import { Calendar } from '@3plearning/react-components';
import moment from 'moment';
import propTypes from 'prop-types';
import { t } from '@lingui/macro';
import { useSelector, useDispatch } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import {
  AssignLaterModalOuter,
  AssignLaterModalInner
} from './assign-later.styled';
import useAssignmentsToAssign from '../../helpers/hooks/use-assignment-to-assign';
import Resources from '../../helpers/resources';
import { getTopics } from '../../containers/course-assign/course-assign-actions';
import { showToast } from '../toast/toast-action';
import { mapSelectedActivitiesToReq } from '../../helpers/resources-helper';
import { ERROR_DETECTED } from '../../containers/course-assign/course-assign-types';
import { HIDE_ASSIGN_LATER } from './store/assign-later.actions';
import {
  useAssignmentFlowTracking,
  summarizeAssignments
} from '../../analytics';

function AssignLaterModal(props) {
  const { i18n } = props;
  const { track } = useAnalytics();
  const assignFlow = useAssignmentFlowTracking('assign');
  const isOpen = useSelector(
    (state) => state.assignLaterReducer.isAssignLaterModalOpen
  );
  const [dateSelected, setDateSelected] = useState({
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().add(1, 'day').format('YYYY-MM-DD')
  });
  const [timeSelected, setTimeSelected] = useState();
  const [enableAccept, setEnableAccept] = useState(true);
  const dispatch = useDispatch();

  const courseID = useSelector(
    (state) => state.CourseAssignReducer.activeCourseID
  );
  const classroomId = useSelector(
    (state) => state.CourseAssignReducer.activeClass
  );
  const groupId = useSelector((state) => state.CourseAssignReducer.activeGroup);

  const onDateChangeHandler = (startDate, endDate) => {
    setDateSelected({ startDate, endDate });
  };
  const onTimeChangeHandler = (newTime) => setTimeSelected(newTime);
  const assignmentsToAssign = useAssignmentsToAssign();

  function handleSuccess() {
    setEnableAccept(true);
    dispatch(getTopics(classroomId, groupId));
    track('ActivityAssigned');
    assignFlow.confirm({
      target: 'students',
      ...summarizeAssignments(assignmentsToAssign)
    });
    dispatch(
      showToast(
        i18n._(
          t(
            'footer.assignSuccess'
          )`Selected student activities have been assigned`
        ),
        'success'
      )
    );
    dispatch({
      type: 'SUBMIT_ASSIGN_LATER',
      payload: { timeSelected, dateSelected }
    });
  }

  // Adds space before period so moment can calculate correctly
  function splitPeriod(time) {
    return `${time.slice(0, time.length - 2)} ${time.slice(time.length - 2)}`;
  }

  const defaultProps = {
    range: {
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().add(1, 'year').format('YYYY-MM-DD')
    },
    closedOnLoad: true,
    initialDate: dateSelected,
    reactDatesConfig: {
      disabled: false
    },
    weeklyRangeOnly: false,
    includeTimeRange: true,
    enableAccept,
    onDatesPicked: onDateChangeHandler,
    onTimesPicked: onTimeChangeHandler,
    onClose: () => {},
    onDateTimeSubmit: () => handleAssignLater(),
    onDateTimeClose: () => dispatch({ type: HIDE_ASSIGN_LATER })
  };

  function handleAssignLater() {
    const MOMENT_DATE_FORMAT = 'DD-MMM-YYYY';
    const startDate = moment(dateSelected.startDate).format(MOMENT_DATE_FORMAT);
    const endDate = moment(dateSelected.endDate).format(MOMENT_DATE_FORMAT);
    const dueDate = moment(
      `${endDate} ${splitPeriod(timeSelected[1])}`
    ).toISOString();
    const requestBody = {
      courseId: courseID,
      startDate: moment(
        `${startDate} ${splitPeriod(timeSelected[0])}`
      ).toISOString(),
      dueDate,
      hasDueDate: true,
      ...mapSelectedActivitiesToReq(assignmentsToAssign)
    };

    assignFlow.start({
      target: 'students',
      dueDate: requestBody.dueDate,
      ...summarizeAssignments(assignmentsToAssign)
    });
    setEnableAccept(false);

    Resources.assign
      .post({ classroomId, groupId })
      .withBody(requestBody)
      .send()
      .then(
        () => handleSuccess(),
        (err) => {
          dispatch({
            type: ERROR_DETECTED,
            payload: err
          });
        }
      );
  }

  return (
    <>
      {isOpen ? (
        <AssignLaterModalOuter>
          <AssignLaterModalInner>
            <Calendar {...defaultProps} />
          </AssignLaterModalInner>
        </AssignLaterModalOuter>
      ) : null}
    </>
  );
}
AssignLaterModal.propTypes = {
  i18n: propTypes.object
};

export default AssignLaterModal;



// WEBPACK FOOTER //
// ./components/assign-later/assign-later.js